import { ArrowForwardOutline } from 'react-ionicons';
import styled from 'styled-components';
import { ArrowBackOutline } from 'react-ionicons';

const red = '#ee2a24';
const blue = '#003876';
const blue2 = '#295A9E';

const getColor = (color) => (color == 'red' ? red : blue);

const CtcButton = styled.button`
  font-weight: 700;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.25rem;
  width: 120px;
  background-color: ${(props) =>
    props.color ? getColor(props.color) : '#eee'};
  &:focus {
    outline: 0;
    opacity: 1;
    border: 0;
  }
`;

const LoginButton = styled.button`
  font-weight: 500;
  margin: 15px;
  height: 70px;
  width: 93%;
  font-family: 'Montserrat';
  transition: all 0.3s ease;
  justify-content: center;
  align-items: center;
  font-size: 1.25rem;
  background-color: ${blue};
  color: white;
  border: 0px;
  border-radius: 5px;
  &:focus {
    outline: 0;
    opacity: 1;
    border: 0;
  }
  &:hover {
    background-color: #0b5ba3;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.4);
    cursor: pointer;
    font-weight: 700;
  }
`;
const MomitirButtom = styled.button`
  background-color: white;
  width: 70px;
  height: 25px;
  float: right;
  border: none;
  color: ${blue};
  border-radius: 2px;
`;
const MSiguienteButtomInside = styled.button`
  background-color: ${blue};
  width: 100px;
  height: 25px;
  color: white;
  float: right;
  margin-right: 8%;
  border: none;
  border-radius: 3px;
  font-family: 'Montserrat';
  transition: all ease 0.3s;
  &:focus {
    outline: 0;
    opacity: 1;
    border: 0;
  }
  &:hover {
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.4);
    cursor: pointer;
  }
`;

const MSiguienteButtom = ({ onClick, Text }) => {
  return (
    <>
      <MSiguienteButtomInside
        onClick={() => onClick()}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        {Text}
        <ArrowForwardOutline
          color={'#00000'}
          style={{ paddingTop: '5px', paddingLeft: '5px' }}
          width="16px"
        />
      </MSiguienteButtomInside>
    </>
  );
};

const MAnteriorButtomInside = styled.button`
  background-color: white;
  font-family: 'Montserrat';
  width: 100px;
  height: 25px;
  float: left;
  border: solid #00387599 1px;
  color: ${blue2};
  border-radius: 3px;
  margin-left: 112px;
  transition: all ease 0.3s;
  &:focus {
    outline: 0;
    opacity: 1;
    border: 0;
  }
  &:hover {
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.4);
    cursor: pointer;
  }
`;

const MAnteriorButtom = ({ onClick, Text }) => {
  return (
    <>
      <MAnteriorButtomInside
        onClick={() => onClick()}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <ArrowBackOutline
          color={'#00000'}
          style={{ paddingTop: '5px', paddingRight: '5px' }}
          width="16px"
        />
        {Text}
      </MAnteriorButtomInside>
    </>
  );
};
const MFinalizarButtom = styled.button`
  background-color: ${blue};
  font-family: 'Montserrat';
  width: 100px;
  height: 25px;
  float: right;
  color: white;
  border: none;
  border-radius: 3px;
  margin-right: -232px;
  transition: all ease 0.3s;

  &:focus {
    outline: 0;
    opacity: 1;
    border: 0;
  }
  &:hover {
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.4);
    cursor: pointer;
  }
`;
const LAtrasButtom = styled.button`
  width: 90px;
  float: right;
  height: 15px;
  border: none;
  color: white;
  background: none;
  margin-top: 5px;
  cursor: pointer;
  font-family: 'Montserrat';
  font-weight: 600;
  transition: all ease 0.3s;

  &:hover {
    cursor: pointer;
  }
`;

export {
  CtcButton,
  LoginButton,
  MomitirButtom,
  MSiguienteButtom,
  MAnteriorButtom,
  MFinalizarButtom,
  LAtrasButtom,
};
